import { memo } from "react";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";

import { API_KEY_GROUP_MAPPING_COLUMN_ID } from "../constants";
import ApiKeyGroupMappingListItemNameCell from "./NameCell";
import ApiKeyGroupMappingListItemStatusCell from "./StatusCell";
import ApiKeyGroupMappingListItemDescriptionCell from "./DescriptionCell";
import ApiKeyGroupMappingListItemDropdownActionsCell from "./DropdownActionsCell";
import { ApiKeyGroupMappingEntity } from "../types";
import { ApiKeyView } from "../../types";

const CELLS = {
  [API_KEY_GROUP_MAPPING_COLUMN_ID.NAME]: ApiKeyGroupMappingListItemNameCell,
  [API_KEY_GROUP_MAPPING_COLUMN_ID.DESCRIPTION]: ApiKeyGroupMappingListItemDescriptionCell,
  [API_KEY_GROUP_MAPPING_COLUMN_ID.STATUS]: ApiKeyGroupMappingListItemStatusCell,
  [API_KEY_GROUP_MAPPING_COLUMN_ID.ACTIONS]: ApiKeyGroupMappingListItemDropdownActionsCell,
};

type ApiKeyGroupMappingListItemProps = {
  group: ApiKeyGroupMappingEntity;
  apiKey: ApiKeyView;
};

const ApiKeyGroupMappingListItem = (props: ApiKeyGroupMappingListItemProps) => {
  const { group, apiKey } = props;

  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as API_KEY_GROUP_MAPPING_COLUMN_ID];
        const uniqueKey = `${id}-${group.id}`;

        const childrenComponent = <Component group={group} apiKey={apiKey} />;

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(ApiKeyGroupMappingListItem);
